import Logo from './Logo';
import React, { Suspense } from 'react';
import LoadingSpinner from './LoadingSpinner';

interface Props {
   children: React.ReactNode;
}

const SuspenseWithLoader = ({ children }: Props) => {
   return <Suspense fallback={<SuspenseLoader />}>{children}</Suspense>;
};

export default SuspenseWithLoader;

export const SuspenseLoader = () => (
   <div className="flex items-center justify-center h-screen ">
      <div className="animate-pulse flex flex-col  items-center">
         {/* <Logo /> */}
         <div className="flex items-center mt-4 gap-4">
            <LoadingSpinner />
            <h1 className="opacity-60"> Loading...</h1>
         </div>
      </div>
   </div>
);
